import { makeStyles } from '@material-ui/styles';
import { colors } from '../../../../../style/colors';
import { ITheme } from '../../../../../style/theme';

export const useStyles = makeStyles((theme: ITheme) => ({
  root: () => ({
    height: '316px',
    width: '350px',
    fontFamily: 'DM Serif Display',
    [theme.breakpoints.down('xs')]: {
      width: 'calc(100% - 8px)',
    },
    backgroundColor: colors.white,
  }),
  cardHeader: {
    display: 'flex',
    placeContent: 'space-between',
  },
  cardContent: {
    flexDirection: 'column',
    placeContent: 'space-evenly',
    height: 180,
  },
  cardDescription: {
    display: 'flex',
    placeItems: 'start',
    padding: '16px 0',
  },
  descriptionTitle: {
    fontWeight: 700,
  },
  contentWrapper: {
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down(780)]: {
      display: 'block',
    },
  },
  descriptionContent: {
    padding: '0 16px',
    width: '230px',
  },
  languageWrapper: {
    display: 'flex',
    placeItems: 'center',
  },
  language: {
    fontWeight: 700,
    paddingLeft: theme.spacing(1),
  },
  meditationIcon: {
    padding: '15px',
    backgroundColor: colors.lightBlue,
    borderRadius: '8px',
  },
}));
